module.exports = {"plans":{"singular":"plan","plural":"plans"}}